import { get } from './http'

export const gtmEvent = (type, rowSystemId, quantity = 1) => {
    return get('/api/cart')
        .then((response) => response.json())
        .then((cart) => pushDataToGtm(type, cart, rowSystemId, quantity))
}

function pushDataToGtm(type, cart, rowSystemId, quantity) {
    const currentProduct = cart.orderRows.find(
        (p) => p.rowSystemId == rowSystemId
    )

    if (currentProduct === undefined) {
        return
    }

    const eventType = type === 'remove' ? 'removeFromCart' : 'addToCart'
    var data = `{
        "event": "${eventType}",
        "ecommerce": {
            "currencyCode": "${currentProduct.currencyCode}",
            "${type}": {
                "products": [{
                    "name":     "${currentProduct.name}",
                    "id":       "${currentProduct.articleNumber}",
                    "price":    "${currentProduct.gaFormattedPrice}",
                    "brand":    "${currentProduct.brand}",
                    "category": "${currentProduct.categoryName}",
                    "quantity":  ${quantity}
                }]
        }
    }}`

    return window.dataLayer.push(JSON.parse(data))
}
